import GroupForm from '../../GroupForm'
import { Group } from '../../../index'
import useUpdateGroupHandler from '../../../effects/update-group'
import { heapEvent } from '@equipmentshare/heaper'

export type EditGroupModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onDeleteClick: () => void,
	selectedGroup: Group,
}

export default function EditGroupModal( { onCancel, onSuccess, onDeleteClick, selectedGroup }: EditGroupModalProps ) {
	const updateGroup = useUpdateGroupHandler()
	const handleSubmit = async( name: string, spendingLimit?: string ) => {
		heapEvent( 'Inventory - Edit Group Modal - Click - Save', {} )
		return await updateGroup( selectedGroup.id, name, spendingLimit )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<GroupForm
			onCancel={handleCancel}
			onSuccess={onSuccess}
			onSubmit={handleSubmit}
			selectedGroup={selectedGroup}
			onDeleteClick={onDeleteClick}
		/>
	)
}
